<div [ngClass]="Theme">

    <ng-container *ngIf="Theme != 'tab-menu-scrollBar' ">
      <ul class="double-tabs">    
        <li *ngFor="let item of Items" [ngClass]="{'active-tab': item.active, 'disabled-tab': item.disabled, 'view-tab': item.viewMenu === true}" (click)="eventTab($event, item)" style="position: relative;">
          <div class="bg-tab" #bgTab></div>
          <div class="inline-text" #textTab>
            <app-text  Theme="BodyRegular" Text="{{item.label}}"></app-text>
            <!-- <div class="monto">
              <app-text  Theme="BodyRegular" Text="${{item.monto | number}}"></app-text>
            </div> -->
          </div>
        </li>      
      </ul>
    </ng-container>
  
  </div>